import React from "react"
import ReactDOM from "react-dom"
import Mopinion from "./mopinion"

export default class MopinionModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<Mopinion {...self.modelJson} />, self.elem)
  }
}
